import React from "react"
import { graphql, useStaticQuery, Link } from "gatsby"
import Img from "gatsby-image"
import {
  Jumbotron,
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Table,
} from "reactstrap"
import Layout from "../components/layout"
import SEO from "../components/seo"

const IndexPage = () => {
  const data = useStaticQuery(graphql`
    query {
      logo: file(relativePath: { eq: "logo.png" }) {
        childImageSharp {
          fluid(maxWidth: 900) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      image1: file(relativePath: { eq: "homeImage1.jpg" }) {
        childImageSharp {
          fixed(width: 225) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      image2: file(relativePath: { eq: "homeImage2.jpeg" }) {
        childImageSharp {
          fixed(width: 225) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      image3: file(relativePath: { eq: "homeImage3.jpeg" }) {
        childImageSharp {
          fixed(width: 225) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      linkedin: file(relativePath: { eq: "linkedin.png" }) {
        childImageSharp {
          fixed(width: 64) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      facebook: file(relativePath: { eq: "facebook.png" }) {
        childImageSharp {
          fixed(width: 64) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      twitter: file(relativePath: { eq: "twitter.png" }) {
        childImageSharp {
          fixed(width: 64) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      instagram: file(relativePath: { eq: "instagram.png" }) {
        childImageSharp {
          fixed(width: 64) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `)
  return (
    <Layout>
      <SEO title="Home" />
      <div
        style={{ minHeight: "100vh", height: "auto" }}
        className="d-flex flex-column"
      >
        <Jumbotron fluid style={{ background: "white" }}>
          <div
            style={{
              width: "100%",
              maxWidth: "900px",
              margin: "0 auto",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Img
              alt="The Calibration Station Logo"
              fluid={data.logo.childImageSharp.fluid}
              placeholderStyle={{ visibility: "hidden" }}
            />
          </div>
        </Jumbotron>
        <Container
          fluid
          className="py-5"
          style={{
            width: "100%",
            flexGrow: 1,
            background: "#222",
            color: "#d8ccc8",
            margin: "0 auto",
          }}
        >
          <Row>
            <Col>
              <h1
                className="raleway-900"
                style={{ textAlign: "center", color: "white" }}
              >
                Expert Vehicle Calibration
              </h1>
            </Col>
          </Row>
          <Row>
            <Col
              sm={{ size: 6, offset: 3 }}
              xl={{ size: 4, offset: 4 }}
              className="d-flex mt-3"
              style={{ textAlign: "center" }}
            >
              <p className="flex-fill">422 Coffee Rd Modesto, CA 95355</p>
              <p className="flex-fill pl-3 pl-0-md">
                1635 T Street Merced, CA 95340
              </p>
            </Col>
          </Row>
          <Row>
            <Col>
              <p style={{ textAlign: "center" }}>
                service@autocalibrationstation.com <br /> (209) 497-6710
              </p>
            </Col>
          </Row>
        </Container>
      </div>
      <Container fluid className="py-5">
        <Row>
          <Col style={{ textAlign: "center" }}>
            <h3 className="font-weight-light raleway-900">WHAT WE DO</h3>
          </Col>
        </Row>
        <Row style={{ textAlign: "center" }}>
          <Col sm={{ size: 8, offset: 2 }}>
            <p className="pt-3">
              <b>
                We are the only purpose-built calibration facility in the
                Central Valley
              </b>
            </p>
            <p className="pt-2">
              The Calibration Station is a facility built for vehicles with
              Advanced Driver Assisted Systems (ADAS). We provide BUMPER TO
              BUMPER / TIRE TO ROOF inspection of your vehicle's ADAS features.
              Your vehicle may require one of three common types of ADAS
              Calibration / Re-Calibration - STATIC (STATIONARY), DYNAMIC, or a
              combination of BOTH - all of which are offered at The Calibration
              Station.
            </p>
          </Col>
        </Row>
        <Row className="py-5">
          <Col sm={{ size: 4, offset: 2 }}>
            <h5>
              <b>When to Calibrate / Re-Calibrate</b>
            </h5>
            <ul>
              <li>Windshield Replacement</li>
              <li>Camera Replacement</li>
              <li>Vehicle Damaged in an Accident</li>
              <li>Frame Damage</li>
              <li>Pillar Post Damage</li>
              <li>Roof Damage</li>
              <li>Pinchweld / Safety Cage Damage</li>
              <li>Front Suspension Repairs</li>
              <li>Component Replacement</li>
              <li>Front End Alignments</li>
              <li>Changes to Vehicle Ride Height </li>
            </ul>
          </Col>
          <Col sm={{ size: 4 }}>
            <h5>
              <b>What You'll Get</b>
            </h5>
            <ul>
              <li>Pre-Scan Calibration Report</li>
              <li>Post Scan Calibration Report</li>
              <li>Proof of Calibration </li>
            </ul>
            <h5>
              <b>Why We're Different</b>
            </h5>
            <ul>
              <li>
                Our technicians are trained and utilize the right equipment, in
                the right environment, with precision, to create OEM quality
                result on every calibration
              </li>
            </ul>
          </Col>
        </Row>

        <Row
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          <Col xs={12} className="pt-4 pb-5" style={{ textAlign: "center" }}>
            <h4>3 TYPES OF CALIBRATION / RE-CALIBRATION</h4>
          </Col>
          <Col
            md={{ size: 4 }}
            xl={{ size: 3 }}
            style={{ textAlign: "center" }}
          >
            <Img
              alt="Static Calibration"
              fixed={data.image1.childImageSharp.fixed}
              style={{ borderRadius: "50%" }}
            />
            <h5 className="pt-3">
              <b>Static (Stationary) Calibration</b>
            </h5>
            <p className="px-3">
              We use specific targets and our proprietary scan tool to align the
              camera at a specific distance, height, and width from the vehicle.
              It is mandatory to create a lane in a shop environment to
              calibrate to the narrowest width of the camera's view.
            </p>
          </Col>
          <Col
            md={{ size: 4 }}
            xl={{ size: 3 }}
            style={{ textAlign: "center" }}
          >
            <Img
              alt="Dynamic Calibration"
              fixed={data.image2.childImageSharp.fixed}
              style={{ borderRadius: "50%" }}
            />
            <h5 className="pt-3">
              <b>Dynamic Calibration</b>
            </h5>
            <p className="px-3">
              We use our proprietary scan tool to calibrate on a road test to
              align the camera while the vehicle in the lane over a specific
              time and speed to calibrate to the widest view of the camera.
            </p>
          </Col>
          <Col
            md={{ size: 4 }}
            xl={{ size: 3 }}
            style={{ textAlign: "center" }}
          >
            <Img
              alt="Static Calibration/ Dynamic Calibration"
              fixed={data.image3.childImageSharp.fixed}
              style={{ borderRadius: "50%" }}
            />
            <h5 className="pt-3">
              <b>Combination Static (Stationary) / Dynamic Calibration</b>
            </h5>
            <p className="px-3">
              There are many vehicles which will require BOTH Static
              (Stationary) and Dynamic performed in sequence.
            </p>
          </Col>
        </Row>

        <Row
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
          className="py-5"
        >
          <Col sm="3">
            <Button color="info" size="lg" block tag={Link} to="/gallery">
              View The Gallery
            </Button>
          </Col>
        </Row>
      </Container>

      <Container
        fluid
        style={{ background: "#222", color: "#d8ccc8" }}
        className="py-5"
      >
        <h3 className="text-center pb-5 raleway-900">CONTACT US</h3>
        <Row>
          <Col md={{ size: 4, offset: 2 }}>
            <b style={{ color: "white" }}>Drop us a line!</b>
            <Form
              action="https://formspree.io/xpzpdqwj"
              method="POST"
              className="py-3 pr-3"
            >
              <FormGroup>
                <Label for="name">Name</Label>
                <Input
                  type="text"
                  name="name"
                  style={{ backgroundColor: "#222", color: "#d8ccc8" }}
                />
              </FormGroup>
              <FormGroup>
                <Label for="_replyto">Your email:</Label>
                <Input
                  type="text"
                  name="_replyto"
                  style={{ backgroundColor: "#222", color: "#d8ccc8" }}
                />
              </FormGroup>
              <FormGroup>
                <Label for="message">Message</Label>
                <Input
                  type="textarea"
                  name="message"
                  style={{ backgroundColor: "#222", color: "#d8ccc8" }}
                />
              </FormGroup>

              <Button
                type="submit"
                style={{
                  width: "100%",
                  margin: "8px 0 0 0",
                  backgroundColor: "#222",
                  color: "#d8ccc8",
                  borderWidth: "3px",
                }}
              >
                Send
              </Button>
            </Form>
          </Col>
          <Col md={{ size: 2 }}>
            <b style={{ color: "white" }}>The Calibration Station</b>
            <p className="py-3">
              <a href="tel:209-497-6710" style={{ color: "#d8ccc8" }}>
                (209) 497-6710
              </a>
            </p>
            <b style={{ color: "white" }}>Hours</b>
            <Table
              size="sm"
              borderless
              className="mt-3"
              style={{ color: "#d8ccc8" }}
            >
              <tr>
                <th scope="row">Mon</th>
                <td>8:00 am – 5:30 pm</td>
              </tr>
              <tr>
                <th scope="row">Tue</th>
                <td>8:00 am – 5:30 pm</td>
              </tr>
              <tr>
                <th scope="row">Wed</th>
                <td>8:00 am – 5:30 pm</td>
              </tr>
              <tr>
                <th scope="row">Thu</th>
                <td>8:00 am – 5:30 pm</td>
              </tr>
              <tr>
                <th scope="row">Fri</th>
                <td>8:00 am – 5:30 pm</td>
              </tr>
              <tr>
                <th scope="row">Sat</th>
                <td>8:00 am – 4:00 pm</td>
              </tr>
              <tr>
                <th scope="row">Sun</th>
                <td>Closed</td>
              </tr>
            </Table>
          </Col>
        </Row>
      </Container>
      <Container fluid className="py-5 text-center">
        <Row className="d-inline-flex flex-row justify-content-center">
          <Col xs="3">
            <a
              href="https://www.facebook.com/The-Calibration-Station-113336186849893/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Img
                alt="Facebook Link"
                fixed={data.facebook.childImageSharp.fixed}
                className="mr-3"
              />
            </a>
          </Col>
          <Col xs="3">
            <a
              href="https://twitter.com/CalibrationThe"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Img
                alt="Twitter Link"
                fixed={data.twitter.childImageSharp.fixed}
                className="mr-3"
              />
            </a>
          </Col>
          <Col xs="3">
            <a
              href="https://www.instagram.com/explore/locations/113336186849893/the-calibration-station/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Img
                alt="Instagram Link"
                fixed={data.instagram.childImageSharp.fixed}
                className="mr-3"
              />
            </a>
          </Col>
          <Col xs="3">
            <a
              href="https://www.linkedin.com/company/the-calibration-station/?viewAsMember=true"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Img
                alt="LinkedIn Link"
                fixed={data.linkedin.childImageSharp.fixed}
                className="mr-3"
              />
            </a>
          </Col>
        </Row>
      </Container>
    </Layout>
  )
}

export default IndexPage
